import { PipeTransform, Pipe } from "@angular/core";
import * as moment from 'moment';

@Pipe({
  name: 'localDateTimePipe4'
})
export class localDateTimePipe4 implements PipeTransform {
  transform(date: string): string {
    let dateOut: moment.Moment = moment(date, "YYYY-MM-DD HH:mm:ss");
    return dateOut.format("DD/MM/YYYY HH:mm:ss");
}
}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/listar-solicitacao/local-date.ts